module.exports = "/_next/static/images/Document@2x-5b02b8b1898d620f23deb613946b39e2.webp";